var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcessBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1900px",
    height: "543px",
    viewBox: "0 0 1900 543",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "4,8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing_03",
    transform: "translate(0.000000, -2266.000000)",
    stroke: "#737373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "process_01",
    transform: "translate(-39.000000, 2000.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,554.080872 C86.1796783,739.234924 205.846345,822.995748 359,805.363342 C588.730483,778.914734 546.885517,554.080872 779,524 C1011.11448,493.919128 979.686698,749.090361 1199,700.733093 C1418.3133,652.375826 1297.72971,427.936454 1618.29623,404.137294 C1938.86275,380.338135 1967.85205,213.850769 1967.85205,185",
    id: "Path-5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessBg);
export default __webpack_public_path__ + "static/media/processBg.6fcdbb7443ec73e9fcd5016831954340.svg";
export { ForwardRef as ReactComponent };